
import { TreeNode } from "primereact/treenode";
import { ProjectDocFolderAttachment } from "../../pages/projectDocs/models/ProjectDocFolderAttachment";
import { ProjectDocFolderSubType } from "../../pages/projectDocs/models/ProjectDocFolderSubType";
import { ProjectDocFolderSurveyType } from "../../pages/projectDocs/models/ProjectDocFolderSurveyType";

export interface PDATreeNode extends TreeNode {
  children: PDATreeNode[];

  FolderTypeId?: number;
  ParentId?: number;
  ChangeParentId?: number;

  SubTypeId?: number,
  SubType?: ProjectDocFolderSubType,

  SurveyTypeId?: number,
  SurveyType?: ProjectDocFolderSurveyType,

  InputControl?: boolean,

  DisablePrimaryEmailNotification?: boolean,

  TemplateId?: number;
  Template?: any;
  bagdeClass?: string;
  bagdeValue?: string;
  StatusId?: number;
  Cypher?: string;
  Attachments?: ProjectDocFolderAttachment[];
}

export const findNode = <T extends PDATreeNode>(nodes: T[], searchKey?: number): T | null => {
  for (let i = 0; i < nodes.length; i++) {
    if (nodes[i].key === searchKey)
      return nodes[i];
  }

  for (let i = 0; i < nodes.length; i++) {
    const res = findNode<T>(nodes[i].children as T[], searchKey);
    if (res != null)
      return res;
  }

  return null;
};

export function findNodePath<T extends PDATreeNode>(nodes: T[], searchKey?: number){
  const path = findPath(nodes, [], searchKey);
  return path.reverse();
}

function findPath<T extends PDATreeNode>(nodes: T[], path: T[], searchKey?: number): T[]{
  for(let i=0; i < nodes.length; i++){
    if(nodes[i].key === searchKey){
      path.push(nodes[i]);
      return path;
    }

    const nestedNodeExist = findPath(nodes[i].children, path, searchKey);
    if(nestedNodeExist.length > 0){
      path.push(nodes[i]);
      return path;
    }
  }

  return path;
}